import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const consent = localStorage.getItem('cookieConsent');

        if (!consent) {
            // Show banner after a short delay for better UX
            setTimeout(() => setShowBanner(true), 1000);
        } else if (consent === 'accepted') {
            // Load Google Tag Manager if previously accepted
            loadGoogleTag();
        }
    }, []);

    const loadGoogleTag = () => {
        // Prevent loading multiple times
        if (window.gtag) return;

        // Load Google Tag Manager script
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-FQ0VZRN1T1';
        document.head.appendChild(script1);

        // Initialize gtag
        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-FQ0VZRN1T1');
        `;
        document.head.appendChild(script2);
    };

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        loadGoogleTag();
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="cookie-consent-overlay" data-nosnippet>
            <div className="cookie-consent-banner">
                <div className="cookie-consent-content">
                    <div className="cookie-consent-text">
                        <h3>We value your privacy</h3>
                        <p>
                            We use cookies to enhance your browsing experience and analyse our traffic.
                            By clicking "Accept", you consent to our use of cookies for analytics purposes.
                        </p>
                    </div>
                    <div className="cookie-consent-actions">
                        <button
                            className="cookie-btn cookie-btn-decline"
                            onClick={handleDecline}
                        >
                            Decline
                        </button>
                        <button
                            className="cookie-btn cookie-btn-accept"
                            onClick={handleAccept}
                        >
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
